module.exports = __webpack_public_path__ + "img/2c1a21a.jpg";